import { render, staticRenderFns } from "./TaskFiles.vue?vue&type=template&id=61df2d8a&scoped=true&"
import script from "./TaskFiles.vue?vue&type=script&lang=js&"
export * from "./TaskFiles.vue?vue&type=script&lang=js&"
import style0 from "./TaskFiles.vue?vue&type=style&index=0&id=61df2d8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61df2d8a",
  null
  
)

export default component.exports